import React, { useState, forwardRef, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import membersAPI from "../../../../services/members";
import { Dropdown } from "primereact/dropdown";
import {
  FormatDateToDDMMYYYY,
  ParseDateFromDDMMYYYY,
} from "../../../../utils/dates";

const UpdateMemberModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState(null);

  useEffect(() => {
    setName(props?.member?.name);
    setFirstname(props?.member?.firstname);
    setLastname(props?.member?.lastname);
    setEmail(props?.member?.email);
    setPhone(props?.member?.phone);
    setAddress(props?.member?.address);
    setPostalCode(props?.member?.postal_code);
    setCity(props?.member?.city);
    setGender(props?.member?.gender);
    setBirthday(
      props?.member?.birthday
        ? ParseDateFromDDMMYYYY(props?.member?.birthday, false)
        : null
    );
  }, [props]);

  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Editer le profil"
        serviceAPI={membersAPI}
        id={props?.member?.id}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        data={{
          name: name,
          firstname: firstname,
          lastname: lastname,
          email: email,
          gender: gender,
          birthday: FormatDateToDDMMYYYY(birthday),
          phone: phone,
          address: address,
          postal_code: postalCode,
          city: city,
        }}
      >
        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex-1 flex-column">
            <label
              htmlFor="lastname"
              className="block text-900 font-medium mb-2"
            >
              Nom de famille
            </label>
            <InputText
              id="lastname"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
              className="w-full mb-1"
            />
          </div>

          <div className="p-inputgroup flex-1 flex-column">
            <label
              htmlFor="firstname"
              className="block text-900 font-medium mb-2"
            >
              Prénom
            </label>
            <InputText
              id="firstname"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
              className="w-full mb-1"
            />
          </div>
        </div>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex-1 flex-column">
            <label htmlFor="name" className="block text-900 font-medium mb-2">
              Nom d'usage
            </label>
            <InputText
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full mb-1"
            />
          </div>

          <div className="p-inputgroup flex-1 flex-column">
            <label htmlFor="gender" className="block text-900 font-medium mb-2">
              Genre
            </label>
            <Dropdown
              id="gender"
              value={gender}
              options={[
                { label: "", value: "N" },
                { label: "Masculin", value: "B" },
                { label: "Féminin", value: "G" },
              ]}
              onChange={(e) => setGender(e.value)}
              optionLabel="label"
              className="w-full mb-1"
            />
          </div>
        </div>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex-1 flex-column">
            <label htmlFor="phone" className="block text-900 font-medium mb-2">
              Téléphone
            </label>
            <InputText
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full mb-1"
            />
          </div>
        </div>

        <div className="card flex flex-column gap-2">
          <div className="p-inputgroup flex-1 flex-column">
            <label htmlFor="email" className="block text-900 font-medium mb-2">
              Email
            </label>
            <InputText
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mb-1"
            />
            <small className="text-600 block mt-1 flex align-items-center gap-1">
              <i className="pi pi-info-circle text-orange-500" style={{ fontSize: '1rem' }}></i>
              <span>L'adresse e-mail doit être unique et ne doit pas être utilisée par un autre membre de l'école.</span>
            </small>
          </div>
        </div>
      </MeaUpdateModal>
    </>
  );
});

export default UpdateMemberModal;
